(() => {
  if (window.EuphoriaAesthetic) return;
  const configElement = document.getElementById('ea-config');
  const dataElement = document.getElementById('ea-data');
  if (!configElement || !dataElement) return;
  let config, data;
  try { config = JSON.parse(configElement.textContent); data = JSON.parse(dataElement.textContent); }
  catch (_) { return; }
  if (!Array.isArray(data) || data.length < 2) return;
  const status = document.getElementById('ea-load-status');
  const launcher = document.querySelector('.ea-launcher');
  const text = config.strings;
  document.querySelectorAll('.ea-worlds__rail').forEach(rail => {
    let near = false;
    const hydrate = () => {
      if (!near) return;
      const bounds = rail.getBoundingClientRect();
      rail.querySelectorAll('[data-ea-style-image]').forEach(template => {
        const rect = template.closest('.ea-style-card').getBoundingClientRect();
        if (rect.right < bounds.left - rect.width || rect.left > bounds.right + rect.width) return;
        const content = template.content.cloneNode(true);
        content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        template.replaceWith(content);
      });
    };
    new IntersectionObserver(entries => { near = entries[0].isIntersecting; hydrate(); }, { rootMargin: '300px 0px' }).observe(rail);
    rail.addEventListener('scroll', hydrate, { passive: true });
    const tarot = rail.querySelector('.ea-style-card__tarot');
    if (tarot) new IntersectionObserver(entries => {
      tarot.style.animationPlayState = entries[0].isIntersecting ? '' : 'paused';
    }).observe(tarot);
  });
  let loading;
  function load() {
    if (loading) return loading;
    loading = (async () => {
      const style = document.createElement('link');
      style.rel = 'stylesheet'; style.href = config.cssUrl;
      const styled = new Promise((resolve, reject) => {
        style.onload = resolve; style.onerror = reject;
        setTimeout(() => reject(new Error('Style load timeout')), 15000);
      });
      document.head.append(style);
      const [module, questions] = await Promise.all([
        import(config.moduleUrl),
        fetch(config.questionsUrl).then(response => {
          if (!response.ok) throw new Error('Questions unavailable');
          return response.json();
        }), styled,
      ]);
      return module.createExperience({ config, data, questions });
    })().catch(error => { loading = null; throw error; });
    return loading;
  }
  async function open(trigger) {
    status.textContent = text.loading;
    trigger?.setAttribute('aria-busy', 'true');
    try { const experience = await load(); experience.open(trigger); status.textContent = ''; }
    catch (_) { status.textContent = text.load_error; }
    finally { trigger?.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ea-open]');
    if (!trigger) return;
    event.preventDefault(); open(trigger);
  });
  window.EuphoriaAesthetic = { open, load };
  if (launcher) {
    launcher.hidden = false;
    let frame;
    const selectors = '#shopify-pc__banner, .shopify-pc__banner__dialog, #PBarNextFrameWrapper, #ShopifyChat, #ShopifyChatContainer, shopify-chat, [data-sticky-add-to-cart], .sticky-add-to-cart, .sticky-cart, .shopify-payment-button, .product-form__submit, iframe[title*="chat" i]';
    function measure() {
      frame = null;
      const modalOpen = document.querySelector('cart-drawer.active, #WishlistDrawer.is-open, .wishlist-drawer.is-open, details.menu-opening, dialog[open]') || document.body.classList.contains('wishlist-open');
      launcher.toggleAttribute('data-obscured', !!modalOpen);
      if (modalOpen) return;
      launcher.style.setProperty('--ea-avoid', '0px');
      document.documentElement.style.setProperty('--ea-shared-lift', '0px');
      const base = launcher.getBoundingClientRect();
      let bottom = base.bottom;
      const obstacles = [...document.querySelectorAll(selectors)].map(element => {
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return { rect, visible: rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' };
      }).filter(item => item.visible && item.rect.top < innerHeight && item.rect.bottom > 0 && item.rect.right > base.left && item.rect.left < base.right).sort((a,b) => b.rect.bottom - a.rect.bottom);
      for (const { rect } of obstacles) {
        if (bottom > rect.top - 12 && bottom - base.height < rect.bottom + 12) bottom = rect.top - 12;
      }
      if (bottom - base.height < 55) launcher.setAttribute('data-obscured', '');
      else {
        const lift = `${Math.max(0, base.bottom - bottom)}px`;
        launcher.style.setProperty('--ea-avoid', lift);
        document.documentElement.style.setProperty('--ea-shared-lift', lift);
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target !== launcher && !launcher.contains(record.target))) schedule();
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden'] });
    schedule();
  }
  const params = new URLSearchParams(location.search);
  if (document.querySelector('[data-ea-result]') && params.get('from') === 'quiz') {
    load().then(experience => experience.showResult()).catch(() => { status.textContent = text.load_error; });
  }
})();
